type Props = {
  fillClassName?: string;
  height?: number;
  width?: number;
  className?: string;
};

export const Arrow = (props: Props) => {
  const { fillClassName, height = 16, width = 17, className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 17 16"
      className={className}
    >
      <g clipPath="url(#acd)">
        <path
          // fill={color}
          className={fillClassName}
          fillRule="evenodd"
          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 1 0-.7.7l2.14 2.15H4.5z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="acd">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
